var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "official_page" },
    [
      _c("page-title", _vm._b({}, "page-title", { ..._vm.pT }, false)),
      _c(
        "div",
        { staticClass: "page-main" },
        [
          _vm._l(_vm.typeList, function (item) {
            return _c("div", {
              key: item.value,
              staticClass: "official_page_type",
              class: _vm.tutorialType === item.value ? "action" : "",
              domProps: { textContent: _vm._s(item.label) },
              on: { click: () => _vm.setTutorialType(item) },
            })
          }),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("business-group", {
        ref: "businessGroup",
        attrs: {
          formValues: _vm.formValues,
          tableConfig: { ..._vm.tableConfig },
          formConfig: { ..._vm.formConfig },
        },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function (record) {
              return [
                _c(
                  "a-button",
                  {
                    attrs: { type: "link" },
                    on: {
                      click: function ($event) {
                        return _vm.edit(record)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                _c(
                  "a-button",
                  {
                    attrs: { type: "link" },
                    on: {
                      click: function ($event) {
                        return _vm.del(record)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
                _c(
                  "a-button",
                  {
                    attrs: { type: "link" },
                    on: {
                      click: function ($event) {
                        return _vm.details(record)
                      },
                    },
                  },
                  [_vm._v("查看详情")]
                ),
              ]
            },
          },
          {
            key: "videoCover",
            fn: function (record) {
              return [
                _c("mVideo", {
                  attrs: {
                    title: record.tutorialName,
                    "img-url": record.videoCover,
                    "video-url": record.tutorialVideoUrl,
                  },
                }),
              ]
            },
          },
          {
            key: "tutorialPrefix",
            fn: function (record) {
              return [
                _c("span", {
                  staticClass: "_anw",
                  domProps: { innerHTML: _vm._s(record.tutorialPrefix) },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }